// useSitrepPdfExport.ts
// Hook for exporting SITREPs as PDF via backend endpoint

import axios from 'axios';
import config from 'constants/apiConfig';
import { toast } from 'react-toastify';

export interface SitrepSectionForExport {
  sectionId?: string;
  name: string;
  content: string;
  timestamp?: string;
  isReportBoundary?: boolean;
  /** 1 when the section is nested under a category such as Analytics. */
  depth?: number;
}

interface UseSitrepPdfExportReturn {
  exportPdf: (
    sections: SitrepSectionForExport[],
    sitrepName: string,
    reportTimestamp?: string
  ) => Promise<Blob>;
}

export function useSitrepPdfExport(): UseSitrepPdfExportReturn {
  async function exportPdf(
    sections: SitrepSectionForExport[],
    sitrepName: string,
    reportTimestamp?: string
  ): Promise<Blob> {
    try {
      const response = await axios.post(
        config.apiGateway.sitrep_export_pdf,
        {
          sections,
          sitrepName,
          reportTimestamp,
        },
        {
          responseType: 'blob', // Important: tells axios to expect binary data
        }
      );

      return response.data;
    } catch (error: unknown) {
      const message = error instanceof Error ? error.message : 'Unknown error';
      toast.error(`Failed to generate PDF: ${message}`);
      console.error('useSitrepPdfExport error:', error);
      throw error;
    }
  }

  return { exportPdf };
}
